<template>
  <section class="m_section">
    <!--	s: 	contents-->
    <div class="contents">
      <MobileGnb />
      <div class="tabcont_wrap without_tab regist_wrap mass">
        <h1 class="title with_desc">발신번호 대량등록</h1>
        <div class="tabcontTop">
          <ul>
            <li>2개 이상의 발신번호를 한번에 등록할 수 있습니다.</li>
            <li>샘플 파일을 내려 받아 내용 작성 후 해당 파일을 올려 주세요.</li>
            <li>발신번호 명의자에 따른 서류를 반드시 제출해야 합니다.</li>
            <li>
              통신서비스 이용증명원은 이용 중인 통신사 고객센터에 전화하여 발급받을 수 있습니다. <br /><span class="tabcontTop_extra_desc"
                >SKT 통신서비스 이용증명원은 SKT 고객센터에 생년월일 마스킹 해제를 요청하여 발급받아야 합니다.</span
              >
            </li>
            <li>심사는 보통 평일 기준 48시간 안에 완료되지만, LG유플러스 사정에 따라 더 늦어질 수 있습니다.</li>
            <li><span>※ 첨부 파일형식 : jpg, png, pdf, tiff / 파일 크기 최대 5MB</span></li>
          </ul>
        </div>
        <form @submit.prevent="" autocomplete="off">
          <!-- 휴대폰 본인인증 -->
          <div class="box_wrap inputbox_wrap">
            <div class="box_top flw">
              <h3 class="tit required">휴대폰 본인인증</h3>
              <div class="top_right">
                <div class="empty">
                  <span>본인 명의의 휴대폰 번호만 발신번호 등록이 가능합니다.</span>
                </div>
              </div>
              <div class="top_right">
                <!-- 인증전 -->
                <div class="left_wrap" v-if="!selfAuth">
                  <button class="btn" type="button" @click="fnPopup">휴대폰 본인인증</button>
                  <div style="display: flex; flex-direction: column">
                    <input type="hidden" id="message" value="" />
                    <input type="hidden" id="phone" value="" />
                    <input type="hidden" id="name" value="" />
                    <input type="hidden" id="responseData" value="" />
                  </div>
                  <button id="nice" style="display: none" @click="fnMessage"></button>
                  <!-- 휴대폰번호인증 필수값 -->
                  <form name="form_chk" method="post">
                    <!-- <input type="hidden" name="recvMethodType" value="get" /> -->
                    <input type="hidden" name="m" value="checkplusService" />
                    <input type="hidden" name="EncodeData" v-model="sEncData" />
                  </form>
                </div>
                <!-- 인증 완료 -->
                <div class="left_wrap" v-if="selfAuth">
                  <button class="btn" type="button" disabled>휴대폰 본인인증</button>
                  <div class="complete">인증 완료</div>
                </div>
              </div>
            </div>
          </div>
          <div class="box_wrap inputbox_wrap" v-if="selfAuth">
            <h2 class="title with_desc">개인정보 수집 &middot; 이용 동의</h2>
            <div class="sendNumberRegTable">
              <div class="inline-box">
              <br/>
              <p>LG유플러스는 U+메시지허브이지 서비스를 제공하기 위해 아래와 같이 개인정보를 수집 및 이용합니다.</p>
              <br/>
              <table>
                <thead>
                  <tr>
                    <th>수집항목</th>
                    <th>이용목적</th>
                    <th>보유 및 이용 기간</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>성명, 주소, 생년월일, 이메일, 주소, <br/>직장명, 직장주소, 직장 전화번호, 부서, 직급/직책</td>
                    <td>서비스 이용을 위한 <br/>발신번호 등록 심사</td>
                    <td><u><strong>해지 후 요금완납일로부터 6개월까지 보관</strong></u></td>
                  </tr>
                </tbody>
              </table>
              <p>※ 개인정보 수집&middot;이용 동의는 거부할 수 있습니다. 다만, 동의 거부시에는 서비스 이용이 제한될 수 있습니다.</p>
              </div>
            </div>
            <div class="chkbox">
              <input type="checkbox" class="chk" id="privacy" v-model="agreePrivacy" />
              <label for="privacy">위 내용에 대해 충분한 설명을 듣고, 내용을 읽어보있으며 이를 이해하며 동의합니다</label>
            </div>
          </div>
          <div v-if="agreePrivacy">
            <!-- 명의자 구분 -->
            <div class="box_wrap radio_wrap">
              <div class="box_top flw mg25t">
                <h3 class="tit required">명의자 구분</h3>
                <div class="top_right">
                  <ul>
                    <li>
                      <input type="radio" name="businessman" class="radio" id="businessman1" value="01" v-model="nmineeDivCd" @change="contView('01')" />
                      <label for="businessman1">사업자(본인,대표,임직원)</label>
                    </li>
                    <li>
                      <input type="radio" name="businessman" class="radio" id="businessman2" value="02" v-model="nmineeDivCd" @change="contView('02')" />
                      <label for="businessman2">타사업자</label>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <!-- 사업자등록증 인증 전 -->
            <div class="box_wrap inputbox_wrap">
              <div class="box_top flw">
                <h3 class="tit required">사업자등록증</h3>
                <div class="top_right jfs">
                  <div class="left_wrap">
                    <!-- <label for="right" class="label">사업자등록증</label> -->
                    <div class="btn plus" :class="selfAuth ? (regFile.data01.file ? 'disabled' : '') : 'disabled'">
                      파일 첨부
                      <input type="file" accept="image/jpeg, image/png, image/pdf, image/tiff" @change="onFileChange" class="form-control-file" id="data01" ref="data01" />
                    </div>
                  </div>
                  <div class="right_wrap">
                    <div class="file_name" v-if="regFile.data01.file">
                      <p class="ellipsis">{{ regFile.data01.file.name | fileTextLengthCut(8, "…") }} ({{ regFile.data01.file.size | formatBytes(0) }})</p>
                      <button class="btn_close" @click="removeImage('data01')"></button>
                    </div>
                    <!-- <div class="empty" v-else>등록된 파일이 없습니다.</div> -->
                  </div>
                </div>
              </div>
              <!-- 사업자등록증 인증 후 -->
              <!-- <div class="box_top flw">
                <h3 class="tit required">사업자등록증</h3>
                <div class="top_right">
                  <div class="complete">사업자 인증 완료</div>
                </div>
              </div> -->
            </div>
  
            <!-- 신분증 (임직원 신청시) -->
            <!-- 2023.04.11 삭제
            <div class="box_wrap inputbox_wrap">
              <div class="box_top flw mg25t" v-if="bizrAuthYn !== 'Y'">
                <h3 class="tit">신분증 <br />(임직원 신청시)</h3>
                <div class="top_right">
                  <div class="empty">
                    <span>임직원 신청시 신분증을 제출해주세요.</span>
                  </div>
                </div>
                <div class="top_right jfs mg0t">
                  <div class="left_wrap">
                    <div class="btn plus" :class="selfAuth ? (regFile.data02.file ? 'disabled' : '') : 'disabled'">
                      파일 첨부
                      <input type="file" accept="image/jpeg, image/png, image/pdf, image/tiff" @change="onFileChange" class="form-control-file" id="data02" ref="data02" />
                    </div>
                  </div>
                  <div class="right_wrap">
                    <div class="file_name" v-if="regFile.data02.file">
                      <p class="ellipsis">{{ regFile.data02.file.name | fileTextLengthCut(8, "…") }} ({{ regFile.data02.file.size | formatBytes(0) }})</p>
                      <button class="btn_close" @click="removeImage('data02')"></button>
                    </div>
                  </div>
                </div>
              </div>-->
              <!-- 신분증 (임직원 신청시) 인증 후 -->
              <!-- 2023.04.11 삭제
              <div class="box_top flw mg25t" v-if="bizrAuthYn === 'Y'">
                <h3 class="tit">신분증<br />(임직원 신청시)</h3>
                <div class="top_right">
                  <div class="complete">제출 완료</div>
                </div>
              </div>
            </div>-->
  
  
            <!-- 통신서비스 이용증명원-->
            <div class="box_wrap inputbox_wrap">
              <div class="box_top flw mg30t">
                <h3 class="tit">
                  <span>통신서비스 이용증명원</span>
                </h3>
                <div class="top_right">
                  <div class="empty">
                    <span>타 통신사는 이용증명원 제출해야 하고, U+의 번호자원은 제출하지 않아도 됩니다.</span>
                  </div>
                </div>
                <div class="top_right jfs mg0t">
                  <div class="left_wrap">
                    <div class="btn plus" :class="regFile.data01.file || (selfAuth === true) ? (bsDoc.data04.file ? 'disabled' : '') : 'disabled'">
                      파일 첨부 <input type="file" accept="image/jpeg, image/png, image/pdf, image/tiff" @change="onFileChange" class="form-control-file" id="data04" ref="data04" />
                    </div>
                    <!-- class="btn"에  "disabled" 추가시 비활성화 -->
                  </div>
                  <div class="right_wrap">
                    <div class="file_name" v-if="bsDoc.data04.file">
                      <p class="ellipsis">{{ bsDoc.data04.file.name | fileTextLengthCut(8, "…") }} ({{ bsDoc.data04.file.size | formatBytes(0) }})</p>
                      <button class="btn_close" @click="removeImage('data04')"></button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
  
            <!-- 재직증명서 (임직원 신청시) -->
            <div class="box_wrap inputbox_wrap">
              <div class="box_top flw mg30t">
                <h3 class="tit">재직증명서 <br />(생년월일만 표시)</h3>
                <div class="top_right">
                  <div class="empty">
                    <span>임직원은 재직증명서를 제출해야 하고, 대표자는 제출하지 않아도 됩니다.</span>
                  </div>
                </div>
                <div class="top_right jfs mg0t">
                  <div class="left_wrap">
                    <div class="btn plus" :class="selfAuth ? (regFile.data03.file ? 'disabled' : '') : 'disabled'">
                      파일 첨부
                      <input type="file" accept="image/jpeg, image/png, image/pdf, image/tiff" @change="onFileChange" class="form-control-file" id="data03" ref="data03" />
                    </div>
                  </div>
                  <div class="right_wrap">
                    <div class="file_name" v-if="regFile.data03.file">
                      <p class="ellipsis">{{ regFile.data03.file.name | fileTextLengthCut(8, "…") }} ({{ regFile.data03.file.size | formatBytes(0) }})</p>
                      <button class="btn_close" @click="removeImage('data03')"></button>
                    </div>
                  </div>
                </div>
              </div>
              <!-- 신분증 (임직원 신청시) 인증 후 -->
              <!-- <div class="box_top flw mg30t" v-if="bizrAuthYn === 'Y'">
                <h3 class="tit">재직증명서<br />(임직원 신청시)</h3>
                <div class="top_right">
                  <div class="complete">제출 완료</div>
                </div>
              </div> -->
            </div>
  
            
            
  
            <!-- 명의자 : 사업자 선택시 -->
            <!-- 2023.04.11 삭제
            <span class="businessman1 box_wrap inputbox_wrap" v-show="nmineeDivCd === '01'">
              <div class="box_wrap inputbox_wrap">
                <div class="box_top flw">
                  <h3 class="tit">제출서류</h3>
                  <div class="top_right">
                    <div class="empty">
                      <span
                        >아래의 필수 서류를 등록해주세요.<br />* 통신서비스 이용증명원을 제출해야 심사 후 발신번호로 등록할 수 있습니다.<br />* 위에 입력한 발신번호와 통신서비스 이용증명원에 적힌 번호가
                        동일해야 발신번호로 등록할 수 있습니다.<br />* 임직원은 재직증명서를 제출해야 하고, 대표자는 제출하지 않아도 됩니다.<br />※ 파일 형식 : jpg, png, pdf, tiff / 파일 크기 최대
                        5MB</span
                      >
                    </div>
                  </div>
                  <div class="top_right jfs">
                    <div class="left_wrap">
                      <label for="right" class="label">통신서비스 이용증명원</label>
                      <div class="btn plus" :class="regFile.data01.file || (bizrAuthYn === 'Y' && selfAuth === true) ? (bsDoc.data04.file ? 'disabled' : '') : 'disabled'">
                        파일 첨부 <input type="file" accept="image/jpeg, image/png, image/pdf, image/tiff" @change="onFileChange" class="form-control-file" id="data04" ref="data04" />
                      </div>
                    </div>
                    <div class="right_wrap">
                      <div class="file_name" v-if="bsDoc.data04.file">
                        <p class="ellipsis">{{ bsDoc.data04.file.name | fileTextLengthCut(8, "…") }} ({{ bsDoc.data04.file.size | formatBytes(0) }})</p>
                        <button class="btn_close" @click="removeImage('data04')"></button>
                      </div>
                    </div>
                  </div>
                  <div class="top_right jfs">
                    <div class="left_wrap">
                      <label for="right" class="label">재직증명서</label>
  
                      <div class="btn plus" :class="regFile.data01.file || (bizrAuthYn === 'Y' && selfAuth === true) ? (bsDoc.data05.file ? 'disabled' : '') : 'disabled'">
                        파일 첨부 <input type="file" accept="image/jpeg, image/png, image/pdf, image/tiff" @change="onFileChange" class="form-control-file" id="data05" ref="data05" />
                      </div>
                    </div>
                    <div class="right_wrap">
                      <div class="file_name" v-if="bsDoc.data05.file">
                        <p class="ellipsis">{{ bsDoc.data05.file.name | fileTextLengthCut(8, "…") }} ({{ bsDoc.data05.file.size | formatBytes(0) }})</p>
                        <button class="btn_close" @click="removeImage('data05')"></button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </span>-->
  
            <!-- 명의자 : 타사업자 선택시 -->
            <span class="businessman2 box_wrap inputbox_wrap" v-show="nmineeDivCd === '02'">
              <!-- 제출서류 -->
              <div class="box_wrap inputbox_wrap">
                <div class="box_top flw mg30t">
                  <h3 class="tit required">위임장</h3>
                  <div class="top_right jfs">
                    <div class="left_wrap">
                      <div class="btn plus" :class="regFile.data01.file || (selfAuth === true) ? (ebsDoc.data12.file ? 'disabled' : '') : 'disabled'">
                        파일 첨부
                        <input type="file" accept="image/jpeg, image/png, image/pdf, image/tiff" @change="onFileChange" class="form-control-file" id="data12" ref="data12" />
                      </div>
                    </div>
                    <div class="right_wrap">
                      <div class="file_name" v-if="ebsDoc.data12.file">
                        <p class="ellipsis">{{ ebsDoc.data12.file.name | fileTextLengthCut(8, "…") }} ({{ ebsDoc.data12.file.size | formatBytes(0) }})</p>
                        <button class="btn_close" @click="removeImage('data12')"></button>
                      </div>
                      <!-- <div class="empty" v-else>등록된 파일이 없습니다.</div> -->
                    </div>
                  </div>
                </div>
              </div>
              <div class="box_wrap inputbox_wrap">
                <div class="box_top flw mg30t">
                  <h3 class="tit required" >위임-수임업체 관계 확인 문서</h3>
                  <div class="top_right jfs">
                    <div class="left_wrap">
                      <div class="btn plus" :class="regFile.data01.file || (selfAuth === true) ? (ebsDoc.data11.file ? 'disabled' : '') : 'disabled'">
                        파일 첨부 <input type="file" accept="image/jpeg, image/png, image/pdf, image/tiff" @change="onFileChange" class="form-control-file" id="data11" ref="data11" />
                      </div>
                      <!-- class="btn"에  "disabled" 추가시 비활성화 -->
                    </div>
                    <div class="right_wrap">
                      <div class="file_name" v-if="ebsDoc.data11.file">
                        <p class="ellipsis">{{ ebsDoc.data11.file.name | fileTextLengthCut(8, "…") }} ({{ ebsDoc.data11.file.size | formatBytes(0) }})</p>
                        <button class="btn_close" @click="removeImage('data11')"></button>
                      </div>
                      <!-- <div class="empty" v-else>등록된 파일이 없습니다.</div> -->
                    </div>
                  </div>
                </div>
              </div>
                  
                  <!-- <div class="top_right jfs">
                    <div class="left_wrap">
                      <label for="right" class="label required">1-3) 법인인감증명서</label>
                      <div class="btn plus" :class="regFile.data01.file || (bizrAuthYn === 'Y' && selfAuth === true) ? (ebsDoc.data13.file ? 'disabled' : '') : 'disabled'">
                        파일 첨부
                        <input type="file" accept="image/jpeg, image/png, image/pdf, image/tiff" @change="onFileChange" class="form-control-file" id="data13" ref="data13" />
                      </div>
                    </div>
                    <div class="right_wrap">
                      <div class="file_name" v-if="ebsDoc.data13.file">
                        <p class="ellipsis">{{ ebsDoc.data13.file.name | fileTextLengthCut(8, "…") }} ({{ ebsDoc.data13.file.size | formatBytes(0) }})</p>
                        <button class="btn_close" @click="removeImage('data13')"></button>
                      </div>
                      <div class="empty" v-else>등록된 파일이 없습니다.</div>
                    </div>
                  </div> -->
              <div class="box_wrap inputbox_wrap">
                <div class="box_top flw mg30t">
                  <h3 class="tit required">위임업체 사업자등록증</h3>
                  <div class="top_right jfs">
                    <div class="left_wrap">
                      <div class="btn plus" :class="regFile.data01.file || (selfAuth === true) ? (ebsDoc.data21.file ? 'disabled' : '') : 'disabled'">
                        파일 첨부
                        <input type="file" accept="image/jpeg, image/png, image/pdf, image/tiff" @change="onFileChange" class="form-control-file" id="data21" ref="data21" />
                      </div>
                    </div>
                    <div class="right_wrap">
                      <div class="file_name" v-if="ebsDoc.data21.file">
                        <p class="ellipsis">{{ ebsDoc.data21.file.name | fileTextLengthCut(8, "…") }} ({{ ebsDoc.data21.file.size | formatBytes(0) }})</p>
                        <button class="btn_close" @click="removeImage('data21')"></button>
                      </div>
                      <!-- <div class="empty" v-else>등록된 파일이 없습니다.</div> -->
                    </div>
                  </div>
                </div>
              </div>
                  <!-- 2023.04.11 삭제
                  <div class="top_right jfs">
                    <div class="left_wrap">
                      <label for="right" class="label required">2-2) 수임사 사업자등록증</label>
  
                      <div class="btn plus" :class="regFile.data01.file || (bizrAuthYn === 'Y' && selfAuth === true) ? (ebsDoc.data22.file ? 'disabled' : '') : 'disabled'">
                        파일 첨부 <input type="file" accept="image/jpeg, image/png, image/pdf, image/tiff" @change="onFileChange" class="form-control-file" id="data22" ref="data22" />
                      </div>
                    </div>
                    <div class="right_wrap">
                      <div class="file_name" v-if="ebsDoc.data22.file">
                        <p class="ellipsis">{{ ebsDoc.data22.file.name | fileTextLengthCut(8, "…") }} ({{ ebsDoc.data22.file.size | formatBytes(0) }})</p>
                        <button class="btn_close" @click="removeImage('data22')"></button>
                      </div>
                    </div>
                  </div>
                  -->
                  <!-- 2023.04.11 삭제
                  <div class="top_right jfs">
                    <div class="left_wrap">
                      <label for="right" class="label">3) 발신번호의 통신서비스 이용증명원</label>
                      <div class="btn plus" :class="regFile.data01.file || (bizrAuthYn === 'Y' && selfAuth === true) ? (ebsDoc.data30.file ? 'disabled' : '') : 'disabled'">
                        파일 첨부 <input type="file" accept="image/jpeg, image/png, image/pdf, image/tiff" @change="onFileChange" class="form-control-file" id="data30" ref="data30" />
                      </div>
                    </div>
                    <div class="right_wrap">
                      <div class="file_name" v-if="ebsDoc.data30.file">
                        <p class="ellipsis">{{ ebsDoc.data30.file.name | fileTextLengthCut(8, "…") }} ({{ ebsDoc.data30.file.size | formatBytes(0) }})</p>
                        <button class="btn_close" @click="removeImage('data30')"></button>
                      </div>
                    </div>
                  </div>-->
                  <!--기획 삭제 22.07.26_PC_모바일_화면검수_발신번호관리.pptx 로 인해 다시 open -->
              <div class="box_wrap inputbox_wrap">
                <div class="box_top flw mg30t">
                  <h3 class="tit">위임업체 대리인 신분증 사본 <br>(생년월일만 표시)</h3>
                  <div class="top_right">
                    <div class="empty">
                      <span>임직원은 재직증명서를 제출해야 하고, 대표자는 제출하지 않아도 됩니다.</span>
                    </div>
                  </div>
                  <div class="top_right jfs">
                    <div class="left_wrap">
                      <div class="btn plus" :class="regFile.data01.file || (selfAuth === true) ? (ebsDoc.data42.file ? 'disabled' : '') : 'disabled'">
                        파일 첨부
                        <input type="file" accept="image/jpeg, image/png, image/pdf, image/tiff" @change="onFileChange" class="form-control-file" id="data42" ref="data42" />
                      </div>
                    </div>
                    <div class="right_wrap">
                      <div class="file_name" v-if="ebsDoc.data42.file">
                        <p class="ellipsis">{{ ebsDoc.data42.file.name | fileTextLengthCut(8, "…") }} ({{ ebsDoc.data42.file.size | formatBytes(0) }})</p>
                        <button class="btn_close" @click="removeImage('data42')"></button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="box_wrap inputbox_wrap">
                <div class="box_top flw mg30t">
                  <h3 class="tit">수임업체 대리인 신분증 사본 <br>(생년월일만 표시)</h3>
                  <div class="top_right">
                    <div class="empty">
                      <span>임직원은 재직증명서를 제출해야 하고, 대표자는 제출하지 않아도 됩니다.</span>
                    </div>
                  </div>
                  <div class="top_right jfs">
                    <div class="left_wrap">
                      <div class="btn plus" :class="regFile.data01.file || (selfAuth === true) ? (ebsDoc.data52.file ? 'disabled' : '') : 'disabled'">
                        파일 첨부
                        <input type="file" accept="image/jpeg, image/png, image/pdf, image/tiff" @change="onFileChange" class="form-control-file" id="data52" ref="data52" />
                      </div>
                    </div>
                    <div class="right_wrap">
                      <div class="file_name" v-if="ebsDoc.data52.file">
                        <p class="ellipsis">{{ ebsDoc.data52.file.name | fileTextLengthCut(8, "…") }} ({{ ebsDoc.data52.file.size | formatBytes(0) }})</p>
                        <button class="btn_close" @click="removeImage('data52')"></button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="box_wrap inputbox_wrap">
                <div class="box_top flw mg30t">
                  <h3 class="tit">위임업체 대리인 재직증명서<br>(생년월일만 표시)</h3>
                  <div class="top_right">
                    <div class="empty">
                      <span>임직원은 재직증명서를 제출해야 하고, 대표자는 제출하지 않아도 됩니다.</span>
                    </div>
                  </div>
                  <div class="top_right jfs">
                    <div class="left_wrap">
                      <div class="btn plus" :class="regFile.data01.file || (selfAuth === true) ? (ebsDoc.data41.file ? 'disabled' : '') : 'disabled'">
                        파일 첨부
                        <input type="file" accept="image/jpeg, image/png, image/pdf, image/tiff" @change="onFileChange" class="form-control-file" id="data41" ref="data41" />
                      </div>
                    </div>
                    <div class="right_wrap">
                      <div class="file_name" v-if="ebsDoc.data41.file">
                        <p class="ellipsis">{{ ebsDoc.data41.file.name | fileTextLengthCut(8, "…") }} ({{ ebsDoc.data41.file.size | formatBytes(0) }})</p>
                        <button class="btn_close" @click="removeImage('data41')"></button>
                      </div>
                      <!-- <div class="empty" v-else>등록된 파일이 없습니다.</div> -->
                    </div>
                  </div>
                </div>
              </div>
              <div class="box_wrap inputbox_wrap">
                <div class="box_top flw mg30t">
                  <h3 class="tit">수임업체 대리인 재직증명서 <br>(생년월일만 표시)</h3>
                  <div class="top_right">
                    <div class="empty">
                      <span>임직원은 재직증명서를 제출해야 하고, 대표자는 제출하지 않아도 됩니다.</span>
                    </div>
                  </div>    
                  <div class="top_right jfs">
                    <div class="left_wrap">
                      <div class="btn plus" :class="regFile.data01.file || (selfAuth === true) ? (ebsDoc.data51.file ? 'disabled' : '') : 'disabled'">
                        파일 첨부
                        <input type="file" accept="image/jpeg, image/png, image/pdf, image/tiff" @change="onFileChange" class="form-control-file" id="data51" ref="data51" />
                      </div>
                    </div>
                    <div class="right_wrap">
                      <div class="file_name" v-if="ebsDoc.data51.file">
                        <p class="ellipsis">{{ ebsDoc.data51.file.name | fileTextLengthCut(8, "…") }} ({{ ebsDoc.data51.file.size | formatBytes(0) }})</p>
                        <button class="btn_close" @click="removeImage('data51')"></button>
                      </div>
                      <!-- <div class="empty" v-else>등록된 파일이 없습니다.</div> -->
                    </div>
                  </div> 
                  <!--<div class="top_right">
                      <div class="empty">※ 사업자등록증과 재직증명서는 위임업체, 수임업체 모두 총4장 제출해야 합니다.</div>
                    </div>-->
                </div>
              </div>
            </span>
  
            <!-- 발신번호 -->
            <div class="box_wrap inputbox_wrap two_tit">
              <div class="box_top flw mg25t">
                <h3 class="tit required">발신번호 <br />파일 올리기</h3>
                <div class="top_right">
                  <div class="download_wrap">
                    <p>샘플 파일 내려받기</p>
                    <a href="/sample/sendAddress.xls" class="sample xls" download></a>
                  </div>
                </div>
                <div class="top_right jfs mgt8">
                  <div class="left_wrap">
                    <div class="btn plus" :class="$gfnCommonUtils.isEmpty(callerIdList) ? '' : 'disabled'">
                      파일 올리기
                      <input type="file" ref="ExcelFile" accept="application/vnd.ms-excel,text/comma-separated-values" @change="readExcel" />
                    </div>
                    <!-- class="btn"에  "disabled" 추가시 비활성화 -->
                  </div>
                  <div class="right_wrap">
                    <div class="file_name" v-if="!$gfnCommonUtils.isEmpty(callerIdList)">
                      <p class="ellipsis">{{ fileName | fileTextLengthCut(5, "…") }}</p>
                      <button class="btn_close" @click="removeFile"></button>
                    </div>
                    <!-- <div class="empty" v-else>등록된 파일이 없습니다.</div> -->
                  </div>
                </div>
              </div>
            </div>
          </div>


          <div class="btn_wrap">
            <button type="button" class="btn large_pink" @click="fnSendReq">승인요청</button>
            <button type="button" class="btn large_white" @click="fnRegCancel">취소</button>
          </div>
        </form>
      </div>
    </div>
    <!--	e: 	contents	-->

    <!-- 대량등록 팝업-->
    <div class="popup-wrap" style="display: none">
      <div class="popup regedNumber" style="display: none">
        <div class="pop-cont">
          <p class="pop-tit" v-html="cTitle"></p>
          <p class="pop-desc list_wrap" v-html="cMessage" style="max-height: 350px"></p>
        </div>
        <div class="pop-btn1">
          <button type="button" class="btn large_pink" @click="ModalClose">확인</button>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import store from "@/store";
import * as XLSX from "xlsx";
import sendNumberApi from "../service/sendNumberApi";
import confirm from "@/modules/commonUtil/service/confirm";
import { eventBus } from "@/modules/commonUtil/service/eventBus";
import MobileGnb from "@/components/MobileGnb.vue"; // 로그인 토큰 정보

export default {
  name: "sendNumberManyReg",
  components: { MobileGnb },
  created() {
    this.fnInit();
  },
  mounted() {
    this.fnAdminCheck();
    this.fnGetNiceCheck();
  },
  data() {
    return {
      selfAuth: false,
      loginDiv: false,
      //관리자 인증 변수 H001 일 경우  true
      userDiv: false,
      // 나이스본인인증 암호화 정보
      sEncData: "",
      // 나이스 인증 성공시 받는 사용자 정보
      bizrAuthYn: "",
      autCd: "",
      message: "",
      phone: "",
      name: "",
      excelFile: [], // 엑셀파일
      cTitle: "",
      cMessage: "",
      nmineeDivCd: "01",
      responseData: "",
      subSttusCd: "",
      //발신번호등록
      regFile: {
        data01: { docTpCd: "", file: "" }, // 사업자등록증
        // data02: { docTpCd: "", file: "" }, // 신분증 (임직원 신청시) (2023.04.11 삭제처리)
        data03: { docTpCd: "", file: "" }, // 재직증명서
      },

      // 사업자 제출서류
      bsDoc: {
        data04: { docTpCd: "", file: "" }, // 통신서비스 이용증명원
        // data05: { docTpCd: "", file: "" }, // 재직증명서 (2023.04.11 삭제)
      },

      // 타사업자 제출서류
      ebsDoc: {
        data11: { docTpCd: "", file: "" }, // 1-1) 위임-수임사간 관계 확인 문서
        data12: { docTpCd: "", file: "" }, // 1-2) 위임장
        //data13: { docTpCd: "", file: "" }, // 1-3) 법인인감증명서 (2022.11.14 삭제처리)
        data21: { docTpCd: "", file: "" }, // 2-1) 위임사 사업자등록증
        // data22: { docTpCd: "", file: "" }, // 2-2) 수임사 사업자등록증 (2023.04.11 삭제처리)
        // data30: { docTpCd: "", file: "" }, // 3-0) 발신번호의 통신서비스 이용증명원 (2023.04.11 삭제처리)
        data41: { docTpCd: "", file: "" }, // 4-1) 위임사 재직증명서(임직원 신청시)
        data42: { docTpCd: "", file: "" }, // 4-2) 위임사 신분증(임직원 신청시)
        data51: { docTpCd: "", file: "" }, // 5-1) 수임사 대리인 재직증명서
        data52: { docTpCd: "", file: "" }, // 5-2) 수임사 대리인 신분증
      },
      // 엑셀 데이터
      validator: false,
      hashNum: new Map(), // 연락처 중복 처리 변수 값 (errorCheck 할 경우 function 마다 초기화 진행)
      filePath: false,
      fileName: "",
      fileLength: 0,
      callerIdList: [],
      errorNum: [],
      agreePrivacy: false
    };
  },
  methods: {
    //초기화
    fnInit() {
      this.validator = false;
      this.hashNum = new Map();
      this.allChecked = false;
      this.callerIdList = [];
      this.filePath = false;
      this.fileName = "";
      this.fileLength = 0;
      this.errorNum = [];
      const isAuth = store.getters["login/isAuth"];
      if (isAuth) {
        this.loginDiv = true;
        sendNumberApi
          .selectAutInfo()
          .then((response) => {
            var result = response.data;
            if (result.success) {
              this.autCd = result.data.autCd;
              this.bizrAuthYn = result.data.bizrAuthYn;
              //not 사용자아이디 비로그인 임시개통 비즈마켓 개통
              if (this.autCd !== "H002" && this.subSttusCd !== "00" && this.subSttusCd !== "01") {
                this.userDiv = true;
              }
              this.fnAdminCheck();
            }
          })
          .catch((error) => {
            if (error.response != undefined && error.response != null) {
              if (error.response.status == 403) {
                eventBus.$on("callbackEventBus", () => {
                  this.$router.go(-1);
                });
                confirm.fnConfirm("", "관리자 계정만 접근 가능합니다.", "cbAlert");
              } else {
                confirm.fnAlert("", "오류가 발생하였습니다.", "alert");
              }
            } else {
              confirm.fnAlert("", "오류가 발생하였습니다.", "alert");
            }
          });
      } else {
        this.autCd == "H003";
        confirm.fnAlert("", "다시 로그인 해주세요.", "alert");
      }
    },
    // 관리자 외 접근시 발신번호관리 페이지로 강제 이동
    fnAdminCheck() {
      if (this.autCd == "H003") {
        eventBus.$on("callbackEventBus", () => {
          this.$router.push({ path: "/sendNumberManage/sendNumber" });
        });
        confirm.fnConfirm("", "로그인 후 발신번호를 등록 할 수 있습니다.", "cbAlert");
      }
      if (!this.userDiv && this.autCd == "H002") {
        eventBus.$on("callbackEventBus", () => {
          this.$router.push({ path: "/sendNumberManage/sendNumber" });
        });
        confirm.fnConfirm("", "관리자 아이디만 발신번호를 등록 할 수 있습니다.", "cbAlert");
      }
      if ((!this.userDiv && this.subSttusCd === "00") || this.subSttusCd === "01") {
        eventBus.$on("callbackEventBus", () => {
          this.$router.push({ path: "/sendNumberManage/sendNumber" });
        });
        confirm.fnConfirm("", "가입절차 확인이 완료된 후 발신번호 등록이 가능합니다.", "cbAlert");
        return;
      }
      // if (!this.userDiv && this.autCd == "H005") {
      //   eventBus.$on("callbackEventBus", () => {
      //     this.$router.push({ path: "/sendNumberManage/sendNumber" });
      //   });
      //   confirm.fnConfirm("", "정지된 아이디는 발신번호를 등록 할 수 없습니다.", "cbAlert");
      // }
    },
    // NICE 인증 데이터 가져오기
    async fnGetNiceCheck() {
      sendNumberApi.getNiceCheck({}).then((response) => {
        const result = response.data;
        if (result.success) {
          this.sEncData = response.data.data.sEncData;
        } else {
          confirm.fnAlert("휴대폰 인증", result.message);
        }
      });
    },

    // 본인인증 팝업
    fnPopup() {
      window.open("", "popupChk", "width=480, height=800, top=100, left=100, fullscreen=no, menubar=no, status=no, toolbar=no, titlebar=yes, location=no, scrollbar=no");
      document.form_chk.action = "https://nice.checkplus.co.kr/CheckPlusSafeModel/checkplus.cb";
      document.form_chk.target = "popupChk";
      document.form_chk.methods = "post";
      document.form_chk.submit();
    },
    fnMessage() {
      //this.showModal = false;
      this.message = document.querySelector("#message").value;
      this.responseData = document.querySelector("#responseData").value;
      this.name = document.querySelector("#name").value;
      this.phone = document.querySelector("#phone").value;
      if (this.message === "본인인증 실패") {
        confirm.fnAlert("", this.message, "alert");
      } else {
        this.selfAuth = true;
      }
    },
    onFileChange(event) {
      const files = event.target.files[0];
      const filePath = event.target.value;
      const filePathSplit = filePath.split("\\");
      const filePathLength = filePathSplit.length;
      const fileNameSplit = filePathSplit[filePathLength - 1].split(".");
      const fileExt = fileNameSplit[1] != null ? fileNameSplit[1].toLowerCase() : fileNameSplit[1];

      if (files.size > 5242880) {
        confirm.fnAlert("", "최대 5MB 크기의 파일만 첨부할 수 있습니다.", "alert");
        return false;
      }
      if (!(fileExt === "jpg" || fileExt === "png" || fileExt === "pdf" || fileExt === "tiff")) {
        // confirm.fnAlert("첨부 파일 형식을 확인해 주세요.", "파일 형식 : jpg, png, pdf, tiff / 최대 크기 5MB", "alert");
        confirm.fnAlert("", "첨부 파일 형식을 확인해 주세요. <br />파일 형식 : jpg, png, pdf, tiff / 최대 크기 5MB", "alert");
        event.target.value = "";
        return false;
      }
      //this.files = files;
      //this.fileNm = event.target.files[0].name;

      this.regImage(event);
    },
    regImage(event) {
      const type = event.target.id;
      var input = event.target;
      if (input.files) {
        var reader = new FileReader();
        /* reader.onload = (e) => {
          this.preview = e.target.result;
        };  이미지 URL*/

        // 사업자등록증
        if (type === "data01") {
          this.regFile.data01.file = input.files[0];
          this.regFile.data01.docTpCd = this.nmineeDivCd === "01" ? "06" : "07";

          // 신분증 (임직원 신청시)
        /*} else if (type === "data02") { 2023.04.11 삭제처리
          this.regFile.data02.file = input.files[0];
          this.regFile.data02.docTpCd = "13";*/

          // 재직증명서 (임직원 신청시)
        } else if (type === "data03") {
          this.regFile.data03.file = input.files[0];
          this.regFile.data03.docTpCd = "14";

          // ***[사업자 선택] 통신서비스 이용증명원
        } else if (type === "data04") {
          this.bsDoc.data04.file = input.files[0];
          this.bsDoc.data04.docTpCd = "01";

          // ***[사업자 선택] 재직증명서
        /*} else if (type === "data05") { 2023.04.11 삭제처리
          this.bsDoc.data05.file = input.files[0];
          this.bsDoc.data05.docTpCd = "02";*/

          // ***[타사업자 선택] 1-1) 위임-수임사간 관계 확인 문서
        } else if (type === "data11") {
          this.ebsDoc.data11.file = input.files[0];
          this.ebsDoc.data11.docTpCd = "03";

          // ***[타사업자 선택] 1-2) 위임장
        } else if (type === "data12") {
          this.ebsDoc.data12.file = input.files[0];
          this.ebsDoc.data12.docTpCd = "04";

          // ***[타사업자 선택] 1-3) 법인인감증명서 2022.11.14 삭제처리
          /* } else if (type === "data13") {
          this.ebsDoc.data13.file = input.files[0];
          this.ebsDoc.data13.docTpCd = "12"; */

          // ***[타사업자 선택] 2-1) 위임사 사업자등록증
        } else if (type === "data21") {
          this.ebsDoc.data21.file = input.files[0];
          this.ebsDoc.data21.docTpCd = "10";

          // ***[타사업자 선택] 2-2) 수임사 사업자등록증
        /*} else if (type === "data22") {   2023.04.11 삭제처리
          this.ebsDoc.data22.file = input.files[0];
          this.ebsDoc.data22.docTpCd = "11";*/

          // ***[타사업자 선택] 3)   발신번호의  통신서비스 이용증명원
        /*} else if (type === "data30") {   2023.04.11 삭제처리
          this.ebsDoc.data30.file = input.files[0];
          this.ebsDoc.data30.docTpCd = "01";*/

          // ***[타사업자 선택] 4-1) 위임사 재직증명서 (임직원 신청시)
        } else if (type === "data41") {
          this.ebsDoc.data41.file = input.files[0];
          this.ebsDoc.data41.docTpCd = "09";

          // ***[타사업자 선택] 4-2) 위임사 신분증 (임직원 신청시)
        } else if (type === "data42") {
          this.ebsDoc.data42.file = input.files[0];
          this.ebsDoc.data42.docTpCd = "08";

          // ***[타사업자 선택] 4-1) 수임사 재직증명서 (임직원 신청시)
        } else if (type === "data51") {
          this.ebsDoc.data51.file = input.files[0];
          this.ebsDoc.data51.docTpCd = "15";

          // ***[타사업자 선택] 4-2) 수임사 신분증 (임직원 신청시)
        } else if (type === "data52") {
          this.ebsDoc.data52.file = input.files[0];
          this.ebsDoc.data52.docTpCd = "16";
        }

        reader.readAsDataURL(input.files[0]);
      }
    },
    removeImage(type) {
      if (type === "data01") {
        this.$refs.data01.value = "";
        this.regFile.data01.file = "";
      /*} else if (type === "data02") { 2023.04.11 삭제처리
        this.$refs.data02.value = "";
        this.regFile.data02.file = "";*/
      } else if (type === "data03") {
        this.$refs.data03.value = "";
        this.regFile.data03.file = "";

        // 사업자 선택시
      } else if (type === "data04") {
        this.$refs.data04.value = "";
        this.bsDoc.data04.file = "";
      /*} else if (type === "data05") { 2023.04.11 삭제처리
        this.$refs.data05.value = "";
        this.bsDoc.data05.file = "";*/

        // 타사업자 선택시
      } else if (type === "data11") {
        this.$refs.data11.value = "";
        this.ebsDoc.data11.file = "";
      } else if (type === "data12") {
        this.$refs.data12.value = "";
        this.ebsDoc.data12.file = "";
        /* } else if (type === "data13") { 2022.11.14 삭제처리
        this.$refs.data13.value = "";
        this.ebsDoc.data13.file = ""; */
      } else if (type === "data21") {
        this.$refs.data21.value = "";
        this.ebsDoc.data21.file = "";
      /*} else if (type === "data22") {   2023.04.11 삭제처리
        this.$refs.data22.value = "";
        this.ebsDoc.data22.file = "";*/
      /*} else if (type === "data30") {   2023.04.11 삭제처리
        this.$refs.data30.value = "";
        this.ebsDoc.data30.file = "";*/
      } else if (type === "data41") {
        this.$refs.data41.value = "";
        this.ebsDoc.data41.file = "";
      } else if (type === "data42") {
        this.$refs.data42.value = "";
        this.ebsDoc.data42.file = "";
      } else if (type === "data51") {
        this.$refs.data51.value = "";
        this.ebsDoc.data51.file = "";
      } else if (type === "data52") {
        this.$refs.data52.value = "";
        this.ebsDoc.data52.file = "";
      }
    },
    contView(type) {
      if (type === "01") {
        this.nmineeDivCd === type;
      } else {
        this.nmineeDivCd === type;
      }
    },
    sendNumberAdd() {
      const addSendNumber = { sndrno: "", sndrnoNm: "" };
      this.callerIdList.push(addSendNumber);
    },
    // 엑셀 주소록 읽기
    readExcel(event) {
      this.$store.commit("startSpinner");
      // 확장자 검사
      const filePath = event.currentTarget.value;
      const filePathSplit = filePath.split("\\");
      const filePathLength = filePathSplit.length;
      const fileNameSplit = filePathSplit[filePathLength - 1].split(".");
      const fileExt = fileNameSplit[1];
      this.filePath = filePath;
      this.fileName = event.target.files[0].name;

      if (!(fileExt === "xls")) {
        // confirm.fnAlert("형식오류", "등록 가능한 파일은 xls 입니다.", "alert");
        confirm.fnAlert("", "등록 가능한 파일은 xls 입니다.", "alert");
        event.currentTarget.value = "";
        this.$store.commit("endSpinner");
        return false;
      }
      // 중복 함수 초기화
      this.hashNum = new Map();
      // 오류 번호 저장 변수 초기화
      this.errorNum = [];
      let input = event.target;
      let reader = new FileReader();
      reader.onload = () => {
        let data = reader.result;
        let workBook = XLSX.read(data, { type: "binary" });
        let rows = new Array();
        workBook.SheetNames.forEach(function (sheetName) {
          rows = XLSX.utils.sheet_to_json(workBook.Sheets[sheetName], {
            defval: "",
            raw: false,
          });
        });

        if (rows.length !== 0) {
          // 엑셀파일 헤더값 체크
          const headerInfo = ["발신번호 명", "발신번호"];
          const headerCheck = Object.keys(rows[0]).every((e) => headerInfo.includes(e));

          if (!headerCheck || Object.keys(rows[0]).length === 1) {
            confirm.fnAlert("", "규격이 다른 파일 입니다. <br/>샘플파일을 다운로드 받아 업로드 해주세요.", "alert");
            this.$store.commit("endSpinner");
            this.$refs.ExcelFile.value = "";
            this.excelFile = [];
            return;
          }
        } else {
          confirm.fnAlert("", "발신번호가 없습니다.", "alert");
          this.$store.commit("endSpinner");
          this.$refs.ExcelFile.value = "";
          this.excelFile = [];
          return;
        }

        if (rows.length > 20000) {
          // confirm.fnAlert("최대 전송 건수 초과", "최대 전송할 수 있는 건수가 초과되어 전송이 불가합니다.", "alert");
          confirm.fnAlert("", "발신번호는 20,000건 까지 등록 가능합니다.", "alert");
          this.$store.commit("endSpinner");
          return;
        }

        this.callerIdList = rows
          .map((e, index) => {
            return {
              // 유효성 체크 항목 추가
              sndrnoNm: e["발신번호 명"],
              sndrno: e["발신번호"],
              status: this.errorCheck(index, e["발신번호"]),
              validator: this.validator,
              selected: true,
            };
          })
          .filter((e) => {
            return e.validator === true;
          });
        this.$store.commit("endSpinner");
        //this.$forceUpdate();
      };
      this.excelFile = reader.readAsBinaryString(input.files[0]);
    },
    // 휴대폰 번호 유효성 체크 항목
    errorCheck(index, phoneNumber) {
      //const patten_phone = /^(01[016789]{1}|070)-?[0-9]{3,4}-?[0-9]{4}$/; //핸드폰 번호, 하이픈 상관 X
      const pattern_eng = /[a-zA-Z]/; // 문자
      const pattern_spc = /[~!@#$%^&*()_+|<>?:{}]/; // 특수문자
      const pattern_kor = /[ㄱ-ㅎ|ㅏ-ㅣ|가-힣]/; // 한글체크
      let errorText = "";

      // 휴대폰 번호, 이름, 중복 체크
      if (phoneNumber == "" || phoneNumber == undefined) {
        errorText = "번호없음";
        this.validator = false;
        this.errorNum.push(index + 2);
        return errorText;
      } else if (pattern_eng.test(phoneNumber) || pattern_spc.test(phoneNumber) || pattern_kor.test(phoneNumber)) {
        errorText = "번호오류";
        this.validator = false;
        this.errorNum.push(index + 2);
        return errorText;
      } else {
        /* else if (patten_phone.test(phoneNumber) && this.phone !== phoneNumber) {
        errorText = "미인증 휴대폰 번호";
        this.validator = false;
        this.errorNum.push(index + 2);
        return errorText;
      }  */
        // 중복체크
        if (this.hashNum.has(phoneNumber.replace(/-/g, ""))) {
          errorText = "번호중복";
          this.validator = false;
          return errorText;
        } else {
          errorText = "정상";
          this.validator = true;
          this.hashNum.set(phoneNumber.replace(/-/g, ""), "phone");
        }
      }
      if (this.errorNum.length > 0) {
        // confirm.fnAlert("오류 발생", "파일 업로드 중 오류가 발생하였습니다.<br />오류 line : " + this.errorNum, "alert");
        confirm.fnAlert("", "파일 업로드 중 오류가 발생하였습니다.<br />오류 line : " + this.errorNum, "alert");
      } else {
        // confirm.fnAlert("정상 등록", "정상 등록되었습니다.", "alert");
        confirm.fnAlert("", "정상 등록되었습니다.", "alert");
      }
      return errorText;
    },
    // 선택된 주소록 삭제
    removeFile() {
      this.$refs.ExcelFile.value = ""; // 이미지 중복 가능하도록 input 초기화
      this.fnInit();
    },
    fnValidator() {
      let title = "";
      let msg = "";

      // 발신번호가 휴대전화 번호일 경우, 본인인증 번호만 승인 요청 처리
      /* const patten_phone = /^(01[016789]{1})-?[0-9]{3,4}-?[0-9]{4}$/; //핸드폰 번호, 하이픈 상관 X
      let callerIdListLen = this.callerIdList.filter((e) => {
        return patten_phone.test(e.sndrno);
      }).length;
      let useHpNumber = true;

      if (callerIdListLen > 0) {
        useHpNumber = this.callerIdList
          .filter((e) => {
            return patten_phone.test(e.sndrno);
          })
          .every((e) => {
            return this.$gfnCommonUtils.hpNumberRemoveDash(this.phone) === this.$gfnCommonUtils.hpNumberRemoveDash(e.sndrno);
          });
      } */

      if (!this.selfAuth) {
        title = "";
        msg = "[휴대폰 본인인증]을 진행해 주세요.";
      } else if (!this.regFile.data01.file) {
        title = "";
        msg = "[사업자등록증]을 입력해 주세요";
      // } else if(!this.bsDoc.data04.file) {     2023.05.18 통신서비스 이용증명원 필수 제외
      //   title = "";
      //   msg = "[통신서비스 이용증명원]를 등록해 주세요";
      } else if (this.nmineeDivCd === "02") {
        // 명의자 구분 타사업자의 경우
        if (!this.ebsDoc.data12.file) {
          title = "";
          msg = "[위임장]을 등록해 주세요";
          /* } else if (!this.ebsDoc.data13.file) {
          title = "";
          msg = "[법인인감증명서]을 등록해 주세요"; */
        } else if (!this.ebsDoc.data11.file) {
          title = "";
          msg = "[위임-수임업체 관계 확인 문서]를 등록해 주세요";
        } else if (!this.ebsDoc.data21.file) {
          title = "";
          msg = "[위임업체 사업자등록증]을 등록해 주세요";
        } else if (this.$gfnCommonUtils.isEmpty(this.callerIdList)) {
          title = "";
          msg = "[발신번호 파일]을 첨부해 주세요";
        } else if (this.errorNum.length > 0) {
          title = "";
          msg = "발신번호 파일에 오류 번호가 있습니다<br />발신번호 파일 수정 후 다시 시도해 주세요<br />오류 line : " + this.errorNum;
        /*} else if (!this.ebsDoc.data22.file) {  2023.04.11
          title = "";
          msg = "[수임사 사업자등록증]을 등록해 주세요";
        }*/
        /* else if (!this.ebsDoc.data30.file) {
          title = "";
          msg = "[발신번호의  통신서비스 이용증명원]을 등록해 주세요";
        } */
        }
      } else if (this.$gfnCommonUtils.isEmpty(this.callerIdList)) {
        title = "";
        msg = "[발신번호 파일]을 첨부해 주세요";
        /* } else if (!useHpNumber) {
        // title = "미인증 휴대폰 번호";
        title = "";
        msg = "승인 요청하신 발신번호와<br />본인인증을 진행한 휴대폰 번호가 다릅니다.<br />본인인증을 진행한 휴대폰 번호만 심사가 가능합니다."; */
      } else if (this.errorNum.length > 0) {
        title = "";
        msg = "발신번호 파일에 오류 번호가 있습니다<br />발신번호 파일 수정 후 다시 시도해 주세요<br />오류 line : " + this.errorNum;
      }
      return { title, msg };
    },
    fnSendReq() {
      const validator = this.fnValidator();
      if (validator.msg) {
        confirm.fnAlert(validator.title, validator.msg, "alert");
        return;
      }
      eventBus.$on("callbackEventBus", this.fnSend);
      // confirm.fnConfirm("심사 후 사용 가능", "요청하신 발신번호는 심사 후 사용이 가능합니다.", "confirm");
      confirm.fnConfirm("", "요청하신 발신번호는 심사 후 사용이 가능합니다.", "confirm");
    },
    fnSend() {
      const fd = new FormData();

      // 발신번호 등록에서 발신번호 명 또는 발신번호가 미기입 되었을 경우 전송되지 않습니다.
      const callList = this.callerIdList
        .filter((e) => {
          return e.validator == true;
        })
        .map((e) => {
          return {
            ...e,
            sndrno: this.$gfnCommonUtils.hpNumberRemoveDash(e.sndrno),
          };
        });

      fd.append("callerIdList", JSON.stringify(callList)); //발신번호
      fd.append("slfAuthYn", this.selfAuth ? "Y" : "N"); // 본인인증 여부
      fd.append("slfAuthHp", this.phone); // 본인인증 휴대폰번호
      fd.append("agreePrivacy", this.agreePrivacy ? "Y" : "N");
      fd.append("nmineeDivCd", this.nmineeDivCd); // 명의자 코드 01 : 사업자 / 02 : 타사업자


      if (this.regFile.data01.file) {
        fd.append("files", this.regFile.data01.file); //사업자 인증
        fd.append("docTpCd", this.regFile.data01.docTpCd); // 사업자 코드
      }
      /*if (this.regFile.data02.file) { 2023.04.11 삭제처리
        fd.append("files", this.regFile.data02.file); //신분증 임직원
        fd.append("docTpCd", this.regFile.data02.docTpCd); // 신분증 임직원
      }*/
      if (this.regFile.data03.file) {
        fd.append("files", this.regFile.data03.file); //재직증명서 임직원
        fd.append("docTpCd", this.regFile.data03.docTpCd); //재직증명서 임직원
      }
      if (this.bsDoc.data04.file) {
        fd.append("files", this.bsDoc.data04.file);
        fd.append("docTpCd", this.bsDoc.data04.docTpCd);
      }

      if (this.nmineeDivCd === "01") {
        if (this.bsDoc.data04.file) {
          fd.append("files", this.bsDoc.data04.file);
          fd.append("docTpCd", this.bsDoc.data04.docTpCd);
        }
        /*if (this.bsDoc.data05.file) { 2023.04.11 삭제 처리
          fd.append("files", this.bsDoc.data05.file);
          fd.append("docTpCd", this.bsDoc.data05.docTpCd);
        }*/
      } else if (this.nmineeDivCd === "02") {
        if (this.bsDoc.data04.file) {
          fd.append("files", this.bsDoc.data04.file);
          fd.append("docTpCd", this.bsDoc.data04.docTpCd);
        }
        if (this.ebsDoc.data11.file) {
          fd.append("files", this.ebsDoc.data11.file);
          fd.append("docTpCd", this.ebsDoc.data11.docTpCd);
        }
        if (this.ebsDoc.data12.file) {
          fd.append("files", this.ebsDoc.data12.file);
          fd.append("docTpCd", this.ebsDoc.data12.docTpCd);
        }

        /* if (this.ebsDoc.data13.file) {
          fd.append("files", this.ebsDoc.data13.file);
          fd.append("docTpCd", this.ebsDoc.data13.docTpCd);
        } */

        if (this.ebsDoc.data21.file) {
          fd.append("files", this.ebsDoc.data21.file);
          fd.append("docTpCd", this.ebsDoc.data21.docTpCd);
        }

        /*if (this.ebsDoc.data22.file) {  2023.04.11 삭제처리
          fd.append("files", this.ebsDoc.data22.file);
          fd.append("docTpCd", this.ebsDoc.data22.docTpCd);
        }*/

        /*if (this.ebsDoc.data30.file) {   2023.04.11 삭제처리
          fd.append("files", this.ebsDoc.data30.file);
          fd.append("docTpCd", this.ebsDoc.data30.docTpCd);
        }*/

        if (this.ebsDoc.data41.file) {
          fd.append("files", this.ebsDoc.data41.file);
          fd.append("docTpCd", this.ebsDoc.data41.docTpCd);
        }

        if (this.ebsDoc.data42.file) {
          fd.append("files", this.ebsDoc.data42.file);
          fd.append("docTpCd", this.ebsDoc.data42.docTpCd);
        }

        if (this.ebsDoc.data51.file) {
          fd.append("files", this.ebsDoc.data51.file);
          fd.append("docTpCd", this.ebsDoc.data51.docTpCd);
        }

        if (this.ebsDoc.data52.file) {
          fd.append("files", this.ebsDoc.data52.file);
          fd.append("docTpCd", this.ebsDoc.data52.docTpCd);
        }
      }

      /*  for (var pair of fd.entries()) {
        console.log(pair[0] + " : " + pair[1]);
      } */

      sendNumberApi.callerIdReg(fd).then((response) => {
        if (response.data.success) {
          eventBus.$on("callbackEventBus", () => {
            this.$router.go(-1);
          });
          // confirm.fnConfirm("승인요청 완료", "발신번호 승인요청이 완료되었습니다.", "cbAlert");
          confirm.fnConfirm("", "발신번호 승인요청이 완료되었습니다.", "cbAlert");
        } else {
          this.cTitle = "";
          this.cMessage = response.data.message;
          this.ModalOpen("regedNumber");
        }
      });
    },
    // 취소 확인 팝업
    fnRegCancel() {
      eventBus.$on("callbackEventBus", this.fnCancel);
      confirm.fnConfirm("", "등록을 취소하시겠습니까??", "cReg");
    },
    fnCancel() {
      this.$router.push({ path: "/sendNumberManage/sendNumber" });
    },
    //모달창
    ModalOpen(target) {
      var dimmed = document.getElementsByClassName("dimmed");
      var wrap = document.getElementsByClassName("popup-wrap");
      var obj = document.getElementsByClassName(target);
      obj[0].classList.add("open");
      dimmed[0].style.display = "block";
      wrap[0].style.display = "block";
      obj[0].style.display = "block";
      this.ModalHeight();
      if (target == "address") {
        this.$refs.sendAddr.fnSendAddrInit();
      }
    },
    ModalClose() {
      var dimmed = document.getElementsByClassName("dimmed");
      var wrap = document.getElementsByClassName("popup-wrap");
      var obj = wrap[0].childElementCount;
      dimmed[0].style.display = "none";
      wrap[0].style.display = "none";
      for (var i = 0; i < obj; i++) {
        var target = document.getElementsByClassName("popup");
        target[i].style.display = "none";
        target[i].classList.remove("open");
      }
    },
    ModalHeight() {
      //팝업 heght가 device height보다 클때
      var winH = window.innerHeight,
        obj = document.querySelector(".popup.open"),
        objH = obj.clientHeight;
      if (objH >= winH) {
        obj.classList.add("over");
      }
    },
  },
};
</script>
